import { render, staticRenderFns } from "./DetalhesConcessao.vue?vue&type=template&id=2f3b33eb&"
import script from "./DetalhesConcessao.vue?vue&type=script&lang=js&"
export * from "./DetalhesConcessao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports